module.exports = __webpack_public_path__ + "static/img/Logo.a7b8e63.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Menu/Logo.svg
// module id = 1617
// module chunks = 9 30 34 35 37